<template>
    <div v-if="isLoaded" class="modal-backdrop">
        <div class="modal-content">
            <div class="wrapper w-100">
                <div class="flex-column align-center confirm-success w-100 max-w-540">

                    <img src="https://static.toss.im/illusts/check-blue-spot-ending-frame.png" width="120"
                        height="120" />
                    <h2 class="title">{{ title }}</h2>

                    <div class="response-section w-100">
                        <div class="flex justify-between">
                            <span class="response-label">{{ fields.paymentName.label }}</span>
                            <span class="response-text">{{ paymentName }}</span>
                        </div>

                        <div class="flex justify-between">
                            <span class="response-label">{{ fields.payerName.label }}</span>
                            <span class="response-text">{{ payerName }} 님</span>
                        </div>

                        <div class="flex justify-between">
                            <span class="response-label">{{ fields.payerEmail.label }}</span>
                            <span class="response-text">{{ payerEmail }}</span>
                        </div>

                        <div class="flex justify-between">
                            <span class="response-label">{{ fields.amount.label }}</span>
                            <span class="response-text">{{ amount }} {{ currencyCode }}</span>
                        </div>


                        <div class="w-100">
                            <button class="btn primary w-100" @click="toPaymentHistory">닫기</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                orderId: null,
                paymentName: null,
                payerName: null,
                payerEmail: null,
                amount: null,
                currencyCode: null,
                isLoaded: false,
                title: "결제를 완료했어요",
                fields: {
                    amount: {
                        id: "amount",
                        label: "결제금액",
                    },
                    payerName: {
                        id: "payerName",
                        label: "주문자명",
                    },
                    payerEmail: {
                        id: "payerEmail",
                        label: "이메일",
                    },
                    paymentName: {
                        id: "paymentName",
                        label: "결제명",
                    },
                },
            };
        },
        methods: {
            /**
             * 결제 이력 조회 페이지로 이동시키는 메서드
             */
            toPaymentHistory() {
                this.$router.push('/payments');
            },

            /**
             * 쿼리 파라미터 파싱 메서드
             */
            parseQueryParams() {
                const urlParams = new URLSearchParams(window.location.search);

                this.orderId = urlParams.get("orderId");
                this.paymentName = urlParams.get("paymentName");
                this.payerName = urlParams.get("payerName");
                this.payerEmail = urlParams.get("payerEmail");
                this.amount = urlParams.get("amount");
                this.currencyCode = urlParams.get("currencyCode");
            },

            /**
             * 쿼리 파라미터가 노출되지 않게 지우는 메서드
             */
            removeQueryParams() {
                const baseUrl = window.location.href.split('?')[0];
                window.history.replaceState(null, null, baseUrl);
            },
        },

        /**
         * 1. 쿼리 파라미터 파싱
         * 2. 화면 렌더링
         * 3. 쿼리 파라미터가 노출되지 않도록 제거
         */
        mounted() {
            this.parseQueryParams();
            this.isLoaded = true;
            this.removeQueryParams();
        },
    };
</script>

<style scoped>

    /* ****************** button ****************** */
    .btn {
        padding: 11px 22px;
        border: none;
        border-radius: 8px;

        background-color: #f2f4f6;
        color: #4e5968;
        font-weight: 600;
        font-size: 17px;
        cursor: pointer;
    }

    .btn.primary {
        margin-top: 50px;
        background-color: #4e5968;
        color: #f9fcff;
    }

    /* ****************** layout ****************** */
    .w-100 {
        width: 100%;
    }

    .wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px;
        overflow: auto;
    }

    .max-w-540 {
        max-width: 540px;
    }

    .flex {
        display: flex;
    }

    .flex-column {
        display: flex;
        flex-direction: column;
    }

    .justify-between {
        justify-content: space-between;
    }

    .align-center {
        align-items: center;
    }

    .confirm-success {
        margin-top: 72px;
    }

    .title {
        margin-top: 32px;
        margin-bottom: 0;
        color: #191f28;
        font-weight: bold;
        font-size: 24px;
    }

    .response-section {
        margin-top: 60px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        font-size: 20px;
    }

    .response-section .response-label {
        font-weight: 600;
        color: #333d48;
        font-size: 17px;
    }

    .response-section .response-text {
        font-weight: 500;
        color: #4e5968;
        font-size: 17px;
        padding-left: 16px;
        word-break: break-word;
        text-align: right;
    }

    /* ****************** modal ****************** */

    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
    }

    .modal-content {
        background-color: white;
        border-radius: 8px;
        min-width: 700px;
        max-width: 800px;
        min-height: 50%;
        max-height: 60%;
        overflow-y: hidden;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
</style>